import { Paper, Stack } from "@mui/material";
import { Typography } from "@powerdiary/components-library/lib";
import { ClientDocumentDto } from "types/generated/models";
import DocumentList from "../DocumentList";

export default function SharedDocuments({ documents }: Readonly<{ documents: ClientDocumentDto[] }>) {
    return (
        <Stack spacing={3} data-test-id="section_shared_documents">
            <Typography variant="paragraphExtraLargeSemiBold">Documents Shared with you</Typography>
            <Paper sx={{ padding: 3 }}>
                <DocumentList documents={documents} dataTestIdSuffix="shared" />
            </Paper>
        </Stack>
    );
}
